import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

function SkillsInput({ sectionData, setSectionData }) {
    const [skillInput, setSkillInput] = useState("");

    const handleAddSkill = () => {
        const trimmedSkill = skillInput.trim();
        if (trimmedSkill && !sectionData.skills.includes(trimmedSkill)) {
            setSectionData((prev) => ({
                ...prev,
                skills: [...prev.skills, trimmedSkill],
            }));
        }
        setSkillInput("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddSkill();
        }
    };

    const handleRemoveSkill = (index) => {
        setSectionData((prev) => ({
            ...prev,
            skills: prev.skills.filter((_, i) => i !== index),
        }));
    };

    return (
        <div className="d-flex flex-wrap gap-2 mb-3">
            <div style={{ position: "relative", width: "100%" }} className="d-flex gap-2">
                <div style={{ position: "relative", flex: 1 }}>
                    <input
                        type="text"
                        value={skillInput}
                        onChange={(e) => setSkillInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter skill (Press Enter or Add)"
                        style={{
                            width: "100%",
                            padding: "10px 35px 10px 35px",
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            color: "#333",
                        }}
                    />

                    <FaSearch
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            color: "#999",
                            pointerEvents: "none",
                        }}
                    />
                </div>

                <button
                    onClick={handleAddSkill}
                    className="btn profileBtn save btn-primary"
                    disabled={!skillInput.trim()}
                >
                    Add
                </button>

            </div>

            {sectionData.skills.map((skill, index) => (
                <span
                    key={index}
                    className="badge bg-success d-flex align-items-center"
                    style={{ 
                        padding: "6px 10px", 
                        borderRadius: "20px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        textAlign: "left"
                    }}
                >
                    {skill}
                    <span
                        className="ms-2"
                        style={{ cursor: "pointer", flexShrink: 0 }}
                        onClick={() => handleRemoveSkill(index)}
                    >
                        ×
                    </span>
                </span>
            ))}
        </div>
    );
}

export default SkillsInput;
